import { ComponentContentTypes } from './types/content-types'

export const PAGE_CONTENT_TYPE = ComponentContentTypes.Page
export const PAGE_WRAPPER_CONTENT_TYPE = ComponentContentTypes.PageWrapper

export const HOMEPAGE_SLUG = '/'
export const PAID_HOMEPAGE_SLUG = 'a'
export const GRAMMAR_CHECK_SLUG = 'grammar-check'
export const PLAGIARISM_CHECKER_SLUG = 'plagiarism-checker'
export const BUSINESS_SLUG = 'business'
export const HOMEPAGE_REDESIGN_SLUG = 'homepage-brand-refresh'
export const HOMEPAGE_OPTIMIZATION_SLUG = 'homepage-optimization-57687'
export const PARAPHRASING_TOOL_SLUG = 'paraphrasing-tool'
export const AI_DETECTOR_SLUG = 'ai-detector'
export const AI_HUMANIZER_SLUG = 'ai-humanizer'
export const PAID_STUDENTS_SLUG = 'a/students'
export const PAID_AI_SLUG = 'a/ai'
export const DESKTOP_SLUG = 'desktop'
export const PAID_CITATIONS_SLUG = 'a/citations'
export const SENTENCE_CHECKER_SLUG = 'sentence-checker'
export const PAID_PARAPHRASING_TOOL_SLUG = 'a/paraphrasing'
export const ESSAY_CHECKER_SLUG = 'essay-checker'

export const RESUME_SKILLS_GENERATOR_SLUG = 'ai/ai-writing-tools/resume-skills-generator'
export const RESUME_OBJECTIVE_GENERATOR_SLUG = 'ai/ai-writing-tools/resume-objective-generator'
export const SUMMARIZING_TOOL_SLUG = 'ai/ai-writing-tools/summarizing-tool'

export const GENERIC_FEEDBACK_SLUG = 'resume-feedback-tool'
export const SPECIFIC_FEEDBACK_SLUG = 'resume-job-review-tool'
export const SUMMARIZE_LINK_TOOL_SLUG = 'summarizer-tool'

export const PAID_LP_SLUGS = 'a/'
export const PAID_LP_HERO_SLUGS = [
  'a',
  'a/ai',
  'a/chatgpt',
  'a/citations',
  'a/esl',
  'a/fluency',
  'a/paraphrasing',
  'a/pro',
  'a/professionals',
  'a/proofreading',
  'a/research-paper',
  'a/students',
  'a/time-saving',
  'a/tone',
]
// used for feedback override
export const PROFESSIONAL_TOOL_NEW_SLUGS = [GENERIC_FEEDBACK_SLUG, SPECIFIC_FEEDBACK_SLUG, SUMMARIZE_LINK_TOOL_SLUG]

// feedback module not to be enabled, but limit override necessary
export const PROFESSIONAL_TOOL_BASELINE_SLUGS = [
  RESUME_SKILLS_GENERATOR_SLUG,
  RESUME_OBJECTIVE_GENERATOR_SLUG,
  SUMMARIZING_TOOL_SLUG,
]

// used for tool usage limit override
export const PROFESSIONAL_TOOL_SLUGS = [...PROFESSIONAL_TOOL_NEW_SLUGS, ...PROFESSIONAL_TOOL_BASELINE_SLUGS]

export const WEB_TOOLS_TOP_5_SLUGS = [
  AI_DETECTOR_SLUG,
  GRAMMAR_CHECK_SLUG,
  PLAGIARISM_CHECKER_SLUG,
  AI_HUMANIZER_SLUG,
  PARAPHRASING_TOOL_SLUG,
]

export const DEFAULT_LOCALE = 'en-US'
export const DEFAULT_LANG = 'en'
